namespace TabAurous.Sales {
    export interface DeliveryChallanForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        GstVat: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: DeliveryChallanItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class DeliveryChallanForm extends Serenity.PrefixedContext {
        static formKey = 'Sales.DeliveryChallan';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DeliveryChallanForm.init)  {
                DeliveryChallanForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.LookupEditor;
                var w7 = s.DecimalEditor;
                var w8 = s.ImageUploadEditor;
                var w9 = DeliveryChallanItemsEditor;

                Q.initFormType(DeliveryChallanForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'PartyId', w4,
                    'LedgerName', w2,
                    'Address1', w5,
                    'State', w2,
                    'Country', w2,
                    'TermsId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'CurrencyId', w6,
                    'ExchRate', w7,
                    'GstVat', w2,
                    'UserId', w6,
                    'EmployeeId', w3,
                    'ProductItemImage', w8,
                    'ItemDetails', w9,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w7,
                    'NetWeight', w7,
                    'NetAmount', w7,
                    'CCNetAmount', w7,
                    'Discount', w7,
                    'AdditionalCharges', w7,
                    'GrossAmount', w7,
                    'CCGrossAmount', w7,
                    'Remark', w5,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
